/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
//@flow

// Vendors
import React from 'react';
import { useTranslation } from 'react-i18next';
import ReactHtmlParser from 'react-html-parser';
import SITE_DATA from '../../../lib/data/siteData';

type Props = {
  file: string,
  id: string,
  fallback?: string,
  args?: array,
};

/**
 * @visibleName
 */
const Trans = ({ file, id, fallback, args }) => {
  // let fallbackText = 'missingLabel_' + file + '_' + id;
  let fallbackText = fallback || id;

  const { t } = useTranslation(file);

  let params = {};
  if (args && args.length) {
    for (let i = 0; i < args.length; i++) {
      params[i + 1] = args[i];
    }
  }
  let data = {
    SITE_DATA,
    currentYear: new Date().getFullYear(),
    ...params,
  };
  return <>{ReactHtmlParser(t(id, fallbackText, data))}</>;
};

export default Trans;
